import { render, staticRenderFns } from "./OldNews.vue?vue&type=template&id=099548fa&scoped=true"
import script from "./OldNews.vue?vue&type=script&lang=js"
export * from "./OldNews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099548fa",
  null
  
)

export default component.exports